// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1_KxM","cls2":"QuestionStyles-cls2_LIo QuestionStyles-cls1_KxM"};